const booking = {
  bookingInformation: "예약 정보", // translated 
  cancellationPolicy: "취소 정책", // translated 
  ourCancellationPolicy: "취소 정책", // translated 
  thisAupersedesAnyCancellationPolicyInRemarksAbove:
    "이는 위의 비고에 명시된 취소 정책보다 우선합니다.", // translated 
  thisBookingIsNonNefundable: "이 예약은 환불되지 않습니다.", // translated 
  paymentTerms: "지불 조건", // translated 
  paymentWillBeTakenFromYourDefault: "기본 설정 계좌에서 결제 금액이 인출될 예정입니다.", // translated 
  paymentMethod: "결제 방법", // translated 
  afterTheFreeCancellationPeriodIfApplicable:
    "무료 취소 기간 이후(해당되는 경우)", // translated 
  prebook: "사전 예약", // translated 
  guests: "손님", // translated 
  payment: "지불", // translated 
  byClicking: "클릭하시면", // translated 
  youAreAgreeingToOur: "귀하는 당사의 약관에 동의하는 것입니다.", // translated 
  termsAndConditions: "이용약관", // translated 
  lastBookableDate: "마지막 예약 가능일", // translated 
  customerRemarksTextfield: "고객 의견", // translated 
  request: "요구", // translated 
};


export default booking;
